// extracted by mini-css-extract-plugin
export default {"root":"classes_root__4HwBZ","token-price":"classes_token-price__7e+p8"};